import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/Button";
import { useModal } from "src/hooks/useModal";
import { actionButtonsModalTrns, actionButtonsTrns } from "./trns";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as DeleteIcon } from "src/assets/icons/trash.svg";
import { ReactComponent as PauseIcon } from "src/assets/icons/pause.svg";
import { ReactComponent as CheckIcon } from "src/assets/icons/restore.svg";
import { ReactComponent as EditIcon } from "src/assets/icons/edit.svg";
import { ConfirmationPopupV2 } from "../ConfirmationPopupV2";

const DEFAULT_BUTTON_CLASSNAME =
  "flex items-center justify-center gap-2 w-full h-10 px-5 py-2 text-lg font-semibold";

interface Props {
  isPaused: boolean;
  onDelete: VoidFunction;
  onPause: VoidFunction;
  onRestore: VoidFunction;
  onEdit: VoidFunction;
  isLoading?: boolean;
}

export const ActionButtons: FC<Props> = ({
  isPaused,
  onDelete,
  onPause,
  onRestore,
  onEdit,
  isLoading,
}) => {
  const { t } = useTranslation();
  const confirmationDeletePopup = useModal(false);

  return (
    <div className="flex flex-col items-center md:flex-row gap-3">
      <ConfirmationPopupV2
        {...confirmationDeletePopup}
        description={t(actionButtonsModalTrns.deleteModalDesc)}
        onConfirm={onDelete}
      />
      <Button
        className={DEFAULT_BUTTON_CLASSNAME}
        variant={ButtonVariants.SECONDARY}
        onClick={confirmationDeletePopup.openModal}
      >
        <DeleteIcon />
        <span>{t(actionButtonsTrns.deleteButton)}</span>
      </Button>
      {isPaused ? (
        <Button
          className={DEFAULT_BUTTON_CLASSNAME}
          variant={ButtonVariants.PRIMARY}
          isLoading={isLoading}
          onClick={onRestore}
        >
          <CheckIcon />
          <span>{t(actionButtonsTrns.restoreButton)}</span>
        </Button>
      ) : (
        <Button
          className={DEFAULT_BUTTON_CLASSNAME}
          variant={ButtonVariants.SECONDARY}
          isLoading={isLoading}
          onClick={onPause}
        >
          <PauseIcon />
          <span>{t(actionButtonsTrns.pauseButton)}</span>
        </Button>
      )}
      <Button
        className={DEFAULT_BUTTON_CLASSNAME}
        variant={ButtonVariants.SECONDARY}
        onClick={onEdit}
      >
        <EditIcon />
        <span>{t(actionButtonsTrns.editButton)}</span>
      </Button>
    </div>
  );
};
